import {action, makeAutoObservable, observable} from "mobx";
import {injectable} from "inversify";

export interface IMatchFilter {
	division: string;
	squad: string;
}
export interface IMatchFilterStore {
	get filter(): IMatchFilter;

	setFilter(name: keyof IMatchFilter, value: string): void;
}

@injectable()
export class MatchFilterStore implements IMatchFilterStore {
	@observable private _filter: IMatchFilter = {
		division: "0",
		squad: "0",
	};

	get filter() {
		return this._filter;
	}
	constructor() {
		makeAutoObservable(this);
	}

	@action setFilter(name: keyof IMatchFilter, value: string) {
		this._filter[name] = value;
	}
}
